import { useContext } from 'react';
import { crRoles } from '../../../constants';
import { AuthContext } from '../../../contexts/AuthContext';
import { Context, Provider } from './context';
import RfsLayout from '../../../components/layouts/RfsLayout';
import ContentPaper from '../../../components/layouts/rfs/Content';
import { AppLoader } from '../../../components/common/loader';
import { Button, Grid, Group, Text } from '@mantine/core';
import { InfoCircle } from 'tabler-icons-react';
import { Form } from './form';
import { Header } from '../stockPriceExtension/selectSku';
import PirTable from './table';

const Content = () => {
  const { submit, saveLoading, loading, pir } = useContext(Context);

  const Footer = () => (
    <Grid justify='flex-end'>
      <Grid.Col span={2}>
        <Button
          variant='gradient'
          color='primary'
          fullWidth
          disabled={saveLoading || loading}
          onClick={() => submit()}
        >
          {saveLoading ? <AppLoader size='sm' /> : 'Submit'}
        </Button>
      </Grid.Col>
    </Grid>
  );

  return (
    <ContentPaper footer={pir.length > 0 ? <Footer /> : null}>
      <Header heading={'PIR EXTENSION'} />
      <Form />
      <br />
      {pir.length > 0 && <PirTable pir={pir} loading={loading} />}
    </ContentPaper>
  );
};

const PIRExtension = () => {
  const { crUserRoles } = useContext(AuthContext);
  const allowedRoles = [crRoles.gcc];
  return (
    <Provider>
      <RfsLayout>
        {allowedRoles.some((role) => crUserRoles.includes(role)) ? (
          <Content />
        ) : (
          <ContentPaper>
            <Grid>
              <Grid.Col span={12}>
                <Group className='disclaimer-modal-group'>
                  <InfoCircle color='black' size='2rem' />
                  <Text align='center'>
                    You do not have access to this page. Contact the administrator to obtain
                    permission.
                  </Text>
                </Group>
              </Grid.Col>
            </Grid>
          </ContentPaper>
        )}
      </RfsLayout>
    </Provider>
  );
};

export default PIRExtension;
